import { useEffect, useRef, useState } from "react";

const useCounter = (target) => {
  const ref = useRef(null);
  const [value, setValue] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          let current = 0;
          const step = Math.max(1, Math.round(target / 40));
          const intervalId = setInterval(() => {
            current += step;
            if (current >= target) {
              current = target;
              clearInterval(intervalId);
            }
            setValue(current);
          }, 25);

          observer.unobserve(el);
        });
      },
      { threshold: 0.6 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [target]);

  return { ref, value };
};

export default useCounter;
